const DEFAULT_TAB_FORM = 'form[data-behaviour~="default-tab"]';
const DEFAULT_TAB_ITEM = "sp-button[data-default-tab-button]";
const SELECTED_ICON = "check-alt-color";

function selectDefaultTab(event) {
  const form = event.detail?.form;
  const selected = form?.matches(DEFAULT_TAB_FORM) && form.querySelector(DEFAULT_TAB_ITEM);
  const menu = form?.closest("sp-menu");

  if (!selected || !menu) {
    return;
  }

  menu.querySelectorAll(DEFAULT_TAB_ITEM).forEach((item) => item.removeAttribute("prepend-icon"));
  selected.setAttribute("prepend-icon", SELECTED_ICON);
  selected.closest(".admin-menu__content")?.classList.add("--with-icons");
}

export function installDefaultTab(root = document) {
  root.addEventListener("action-success", selectDefaultTab);

  return () => root.removeEventListener("action-success", selectDefaultTab);
}

installDefaultTab();
